/**
 * 内联 SVG 图标。
 *
 * 不引图标库：控制台总共用得到二十来个图标，内联 path 的体积远小于一个依赖，
 * 也不会因为库的版本变化而改版面。
 */

export type IconName =
  | 'search'
  | 'menu'
  | 'close'
  | 'bell'
  | 'help'
  | 'sun'
  | 'moon'
  | 'chevron-down'
  | 'chevron-right'
  | 'arrow-up-right'
  | 'copy'
  | 'check'
  | 'logout'
  | 'plus'
  | 'trash'
  | 'refresh'
  | 'shield'
  | 'users'
  | 'building'
  | 'key'
  | 'apps'
  | 'list'
  | 'crown'
  | 'drone'
  | 'card'
  | 'lifebuoy'
  | 'alert'
  | 'device'
  | 'clock'
  | 'external';

const PATHS: Record<IconName, string> = {
  search: 'M10.5 3a7.5 7.5 0 1 0 4.55 13.46l3.75 3.74 1.4-1.4-3.74-3.75A7.5 7.5 0 0 0 10.5 3Zm0 2a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11Z',
  menu: 'M3 6h18v2H3V6Zm0 5h18v2H3v-2Zm0 5h18v2H3v-2Z',
  close: 'm6.4 5 5.6 5.6L17.6 5 19 6.4 13.4 12 19 17.6 17.6 19 12 13.4 6.4 19 5 17.6 10.6 12 5 6.4 6.4 5Z',
  bell: 'M12 2a6 6 0 0 0-6 6v3.6L4 15v1h16v-1l-2-3.4V8a6 6 0 0 0-6-6Zm0 19a2.5 2.5 0 0 0 2.45-2h-4.9A2.5 2.5 0 0 0 12 21Z',
  help: 'M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm.02 15.5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5ZM11 6c2.2 0 3.75 1.3 3.75 3.1 0 1.3-.6 2-1.75 2.75-.9.6-1.15.95-1.15 1.7v.35h-2v-.5c0-1.4.45-2.1 1.6-2.85.85-.55 1.15-.85 1.15-1.55 0-.8-.65-1.3-1.6-1.3s-1.7.6-1.75 1.55H8.2C8.25 7.4 9.3 6 11 6Z',
  sun: 'M12 5V2h0v3Zm0 14v3h0v-3Zm7-7h3v0h-3ZM2 12h3v0H2Zm14.95-4.95 2.12-2.12v0l-2.12 2.12ZM4.93 19.07l2.12-2.12v0l-2.12 2.12Zm14.14 0-2.12-2.12v0 2.12 2.12ZM4.93 4.93 7.05 7.05v0L4.93 4.93ZM12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10Z',
  moon: 'M13.5 3a8.5 8.5 0 1 0 7.4 12.7A7 7 0 0 1 13.5 3Z',
  'chevron-down': 'm12 14.4-5-5 1.4-1.4 3.6 3.6 3.6-3.6 1.4 1.4-5 5Z',
  'chevron-right': 'm13.4 12-5-5L9.8 5.6 16.2 12l-6.4 6.4-1.4-1.4 5-5Z',
  'arrow-up-right': 'M7 6h11v11h-2V9.4l-9.3 9.3-1.4-1.4L14.6 8H7V6Z',
  copy: 'M8 2h10a2 2 0 0 1 2 2v12h-2V4H8V2ZM6 6h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2Zm0 2v12h10V8H6Z',
  check: 'm9.6 16.2-4.2-4.2-1.4 1.4 5.6 5.6L20.4 8.2l-1.4-1.4-9.4 9.4Z',
  logout: 'M10 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h5v-2H5V5h5V3Zm4.6 4.4-1.4 1.4 2.2 2.2H8v2h7.4l-2.2 2.2 1.4 1.4L19.4 12l-4.8-4.6Z',
  plus: 'M11 5h2v6h6v2h-6v6h-2v-6H5v-2h6V5Z',
  trash: 'M9 3h6l1 2h4v2H4V5h4l1-2ZM6 8h12l-1 13H7L6 8Zm3 2v9h2v-9H9Zm4 0v9h2v-9h-2Z',
  refresh: 'M12 4a8 8 0 0 1 7.5 5.3l-1.9.7A6 6 0 0 0 6.5 8H9V6H4v5h2V9.4A8 8 0 1 1 12 20v-2a6 6 0 0 0 0-12Z',
  shield: 'M12 2 4 5.5V11c0 5 3.4 9 8 11 4.6-2 8-6 8-11V5.5L12 2Zm0 2.2 6 2.6V11c0 3.9-2.6 7-6 8.7-3.4-1.7-6-4.8-6-8.7V6.8l6-2.6Z',
  users: 'M12 3a4 4 0 1 1 0 8 4 4 0 0 1 0-8Zm0 10c4 0 7 2 7 4.5V20H5v-2.5C5 15 8 13 12 13Zm7.5-.5a3 3 0 1 1 0-6 3 3 0 0 1 0 6ZM4.5 6.5a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z',
  building: 'M4 3h10v18H4V3Zm2 2v2h2V5H6Zm4 0v2h2V5h-2ZM6 9v2h2V9H6Zm4 0v2h2V9h-2Zm-4 4v2h2v-2H6Zm4 0v2h2v-2h-2ZM16 8h4v13h-4V8Z',
  key: 'M14 3a7 7 0 0 0-6.7 9L2 17.3V22h4.7l1.4-1.4V19h1.6l1.4-1.4V16h1.3l1.3-1.3A7 7 0 1 0 14 3Zm3 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z',
  apps: 'M4 4h7v7H4V4Zm9 0h7v7h-7V4ZM4 13h7v7H4v-7Zm9 0h7v7h-7v-7Z',
  list: 'M4 6h2v2H4V6Zm4 0h12v2H8V6ZM4 11h2v2H4v-2Zm4 0h12v2H8v-2ZM4 16h2v2H4v-2Zm4 0h12v2H8v-2Z',
  crown: 'm3 18h18v2H3v-2Zm0-3 2.5-8 4 3.5L12 4l2.5 6.5 4-3.5L21 15H3Z',
  drone: 'M12 9a3 3 0 1 1 0 6 3 3 0 0 1 0-6ZM6 4H4v2H2v2h2v2h2V8h2V6H6V4Zm12 0h2v2h2v2h-2v2h-2V8h-2V6h2V4ZM6 14H4v2H2v2h2v2h2v-2h2v-2H6v-2Zm12 0h2v2h2v2h-2v2h-2v-2h-2v-2h2v-2Z',
  card: 'M3 5h18a1 1 0 0 1 1 1v3H2V6a1 1 0 0 1 1-1Zm-1 6h20v7a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-7Zm3 3v2h5v-2H5Z',
  lifebuoy: 'M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 2a8 8 0 0 1 5.3 2L14.9 8.4a4 4 0 0 0-5.8 0L6.7 6A8 8 0 0 1 12 4Zm-6 8a8 8 0 0 1 .6-3L9 11.4a4 4 0 0 0 0 1.2L6.6 15A8 8 0 0 1 6 12Zm6 6a8 8 0 0 1-5.3-2l2.4-2.4a4 4 0 0 0 5.8 0L17.3 18A8 8 0 0 1 12 18Zm6-6a8 8 0 0 1-.6 3L15 12.6a4 4 0 0 0 0-1.2L17.4 9A8 8 0 0 1 18 12Z',
  alert: 'M12 2 1.5 21h21L12 2Zm1 14h-2v2h2v-2Zm0-7h-2v5h2V9Z',
  device: 'M4 4h16v10H4V4Zm0 12h16v2H4v-2Zm6 4h4v2h-4v-2Z',
  clock: 'M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm1 5h-2v6l5 3 1-1.7-4-2.3V7Z',
  external: 'M14 3h7v7h-2V6.4l-8.3 8.3-1.4-1.4L17.6 5H14V3ZM5 5h5v2H7v10h10v-3h2v5H5V5Z',
};

export interface IconProps {
  name: IconName;
  className?: string;
  /** 装饰性图标传 true，避免读屏软件把图标也念一遍 */
  decorative?: boolean;
}

export function Icon({ name, className = 'h-4 w-4', decorative = true }: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      fill="currentColor"
      aria-hidden={decorative || undefined}
      focusable="false"
    >
      <path d={PATHS[name]} />
    </svg>
  );
}
